import React from 'react'
import classNames from 'classnames'
import Icon from '../Icon'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'

import '../../../assets/sass/components/plans/plan-features.scss'

const SinglePlanFeatures = ({
    plan = "gold",
    featuers = [
        { name: 'Access to all Videos', available: true },
        { name: 'Talent Search', available: true },
        { name: 'Player Evaluation', available: true },
        { name: 'Scouting Reports', available: true },
        { name: 'Report Sharing', available: true },
        { name: 'Player Stats Per Match', available: true },
        { name: 'Player Comparision', available: false },
        { name: 'Watch List', available: false },
        { name: 'Matches and Events', available: false },
        { name: 'Messaging', available: false },
    ]
}) => {
    return (
        <div className={classNames("plan-features", plan)}>
            <ul className="features-list">
                {featuers.map(({ name, available }) => (
                    <li key={name} className={classNames({ available })}>
                        <span className="text">{name}</span>
                        <Icon icon={available ? faCheckCircle : faTimesCircle} />
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default SinglePlanFeatures
